Calendar.locales['hu'] = {
    days: [ "Vasárnap","Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"],
    daysShort: ["Vas", "Hét", "Ked", "Sze", "Csü", "Pén", "Szo"],
    daysMin: ["Va", "Hé", "Ke", "Sz", "Cs", "Pé", "Sz"],
    months: ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"],
    monthsShort: ["Jan", "Feb", "Már", "Ápr", "Máj", "Jún", "Júl", "Aug", "Sze", "Okt", "Nov", "Dec"],
    weekShort: 'h',
    weekStart: 1
};
